












import Vue from 'vue';
import {
  mapActions,
  mapGetters,
} from 'vuex';

import api from '../../api';
import ReviewCards from '../../components/ui/review-cards/review-cards.vue';

import { IUserReviewObject } from '../../../../shared/types';

export default Vue.extend({
  name: 'Reviews',

  components: {
    ReviewCards,
  },

  data: () => ({
    reviews: [] as IUserReviewObject[],
  }),

  async created() {
    this.handlePageLoad({
      name: this.$route.name,
    });
    this.requiresLogin();

    this.reviews = await api.review.getUserReviews(this.getUser.id);
  },

  computed: {
    ...mapGetters('user', [
      'getUser',
    ]),
  },

  methods: {
    ...mapActions('navigation', [
      'handlePageLoad',
      'requiresLogin',
    ]),
  },
});
